export default __webpack_public_path__ + "static/media/28.bd127564.png";